module.exports = __webpack_public_path__ + "static/media/arrow-left.fe85b2e4.svg";